import BaseModel from 'volta/models/base-model';
import { collectionCommand, resourceCommand as command } from 'volta/utils/api';
import { formatISODate } from "volta/utils/date-utils";

import { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

import type { IResourceName } from 'volta/models/base-model';
import type { TResetDayPayload, TUpdateDayPayload } from 'volta/models/types/calendar';

export const SupplierCalendarDayResourceName: IResourceName = {
  singular: 'supplierCalendarDay',
  plural: 'supplierCalendarDays'
};

export enum SupplierCalendarDayEvents {
  CalendarUpdated = 'CalendarUpdated',
  DaysReset = 'DaysReset',
  SupplierCalendarDayReset = 'SupplierCalendarDayReset'
}

export enum SupplierCalendarDayCommands {
  UpdateCalendar = 'UpdateCalendar',
  ResetDays = 'ResetDays',
  ResetOne = 'ResetOne'
}

export default class SupplierCalendarDay extends BaseModel {
  /**
   * Create or update the supplier calendar days
   * @return The list of created or updated SupplierCalendarDay models
   */
  static updateCalendar = collectionCommand<
    TUpdateDayPayload,
    SupplierCalendarDay[],
    typeof SupplierCalendarDay
  >(SupplierCalendarDayCommands.UpdateCalendar);

  /**
   * Effectively deletes the models identified by the supplier id and dates
   * @return Done
   */
  static resetDays = collectionCommand<TResetDayPayload, DoneResult, typeof SupplierCalendarDay>(
    SupplierCalendarDayCommands.ResetDays
  );

  /**
   * Effectively deletes the model identified by the entityId
   * @return Done
   */
  resetOne = command<undefined, SupplierCalendarDay>(SupplierCalendarDayCommands.ResetOne);

  @attr('string') supplierId!: string;
  @attr('date') date!: Date;
  @attr('boolean') openForReception!: boolean;

  get formattedDate() {
    return formatISODate(this.date);
  }

  get indexedDay() {
    const { openForReception } = this;
    return {
      [formatISODate(this.date)]: {
        openForReception
      }
    };
  }

  [Type] = 'supplier-calendar-day' as const;
}
